import React, { useEffect, useState } from 'react';
import { GET_TRANSACTION_CATEGORIES } from '../constants/aryGraphqlSchemas';
import { useAryQuery } from '../hooks/useAryGraphql';
import AryLazyAutoCompleteBase from './AryLazyAutoCompleteBase';

// const PAGE_COUNT = 8;

function ArySelectTransactionGroups({
  transactionCategories,
  onTransactionCategoriesChange,
  onOptionEmpty = () => { },
  ...others
}) {
  const [options, setOptions] = useState([]);
  const [values, setValues] = useState([]);

  const {
    data: getTransactionCategoriesQueryData,
    loading: loadingGetTransactionCategories
  } = useAryQuery({
    gqlConfig: GET_TRANSACTION_CATEGORIES,
    items: `
        code
        title
        hexColor
      `
  });

  useEffect(() => {
    if (getTransactionCategoriesQueryData) {
      const tmpOptions = getTransactionCategoriesQueryData.map(
        (transactionCategory) => ({
          value: transactionCategory.code,
          label: transactionCategory.title
        })
      );
      setOptions(tmpOptions);
    }
  }, [getTransactionCategoriesQueryData]);

  useEffect(() => {
    if (transactionCategories && getTransactionCategoriesQueryData) {
      const tmpValues = transactionCategories.map((transactionCategory) => {
        const tmp = getTransactionCategoriesQueryData.find(
          (dta) => dta.code === transactionCategory
        );
        return {
          value: tmp.code,
          label: tmp.title
        };
      });
      setValues(tmpValues);
    }
  }, [transactionCategories, getTransactionCategoriesQueryData]);

  useEffect(() => {
    if (!options.length) {
      onOptionEmpty();
    }
  }, [options.length]);

  return (
    <AryLazyAutoCompleteBase
      options={options}
      loading={loadingGetTransactionCategories}
      value={values}
      onChange={(selectedObj) => onTransactionCategoriesChange(selectedObj)}
      {...others}
    />
  );
}

export default ArySelectTransactionGroups;
